import {Component, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {FormComponent} from '../form/form.component';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  imports: [
    TranslatePipe,
    FormComponent
  ]
})
export class ContactComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
